import { createSlice } from "@reduxjs/toolkit";
import { ILOBTypes } from "./types";

interface IMasterState {
  insurerList: any;
}

const initialState: IMasterState = {
  insurerList: null,
};

const insurerMaster = createSlice({
  name: "insurerMaster",
  initialState,
  reducers: {
    setInsurerList: (state, action) => {
      console.log("Setting insurer list:", action?.payload);

      state.insurerList = action?.payload?.result || action?.payload || [];
    },
  },
});

export const { setInsurerList } = insurerMaster.actions;
export default insurerMaster.reducer;
